import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  UpdateDetergentHistoryForm,
  UpdateDetergentHistoryPageHeader,
} from '@/components/pages/DetergentHistories/Update'
import routes from '@/constants/routes'
import { useDetergents } from '@/pages/Detergents/Detergent.hooks'
import { DetergentHistory } from '@/types'
import { UpdateDetergentHistoryRequest } from '@/types/apis/detergentHistories/UpdateDetergentHistoryRequest'

import { useDetergentHistories } from '../DetergentHistory.hooks'
import { useGetDetergentHistory, useUpdateDetergentHistories } from './Update.hooks'

const UpdateDetergentHistory = () => {
  const { detergentId, id } = useParams<{ detergentId: string; id: string }>()

  const detergentHistoryId = Number(id)

  const navigate = useNavigate()

  const { updateDetergentHistory, loading: updateLoading } = useUpdateDetergentHistories()
  const { getDetergentHistory, loading: getLoading, response: getDetergentHistoryResponse } = useGetDetergentHistory()
  const { deleteDetergentHistory } = useDetergentHistories()
  const { getDetergentDetail, getDetergentDetailResponse } = useDetergents()

  const handleDeleteDetergentHistory = async (id: DetergentHistory['id']) => {
    await deleteDetergentHistory({ id })
  }

  const handleSubmitForm = async (formValues: UpdateDetergentHistoryRequest) => {
    await updateDetergentHistory({
      quantity: formValues.quantity,
      id: detergentHistoryId,
    })

    const path = routes.detergentHistories.path.replace(':id', detergentId || '')
    navigate(path)
  }

  useEffect(() => {
    if (detergentId) {
      getDetergentDetail(Number(detergentId))
    }
    getDetergentHistory({ id: detergentHistoryId })
  }, [detergentHistoryId, detergentId, getDetergentDetail, getDetergentHistory])

  return (
    <>
      <UpdateDetergentHistoryPageHeader />
      <UpdateDetergentHistoryForm
        {...{
          detergentId: Number(detergentId),
          updateLoading,
          getLoading,
          getDetergentHistoryResponse,
          detergentHistoryId,
          getDetergentDetailResponse,
        }}
        onSubmit={handleSubmitForm}
        onDelete={handleDeleteDetergentHistory}
      />
    </>
  )
}

UpdateDetergentHistory.displayName = 'UpdateDetergentHistory'
export default UpdateDetergentHistory
